import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLargeLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M15.3597 2.61191L10.1439 12.0004L15.3597 21.3889L13.6114 22.3602L7.85596 12.0004L13.6114 1.64062L15.3597 2.61191Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeLeft;
